import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { StyledLabel, StyledLink } from "./_styled";

const RightRailRelatedTopics = ({ label, relations }) => {
  if (!relations?.length) {
    return null;
  }

  return (
    <div>
      <StyledLabel element="h5" fontFamily="primary">
        {label}
      </StyledLabel>
      {relations.map((relatedTopic) => (
        <StyledLink
          key={relatedTopic.link}
          fontSize="sm"
          linkComponent={Link}
          href={relatedTopic.link}
        >
          {relatedTopic.title}
        </StyledLink>
      ))}
    </div>
  );
};

RightRailRelatedTopics.propTypes = {
  label: PropTypes.string,
  relations: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }).isRequired
  ),
};

RightRailRelatedTopics.displayName = "RightRailRelatedTopics";
export default RightRailRelatedTopics;
